import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

export async function fetchShareholderDashboard() {
  const res = await fetch(`${API_BASE}/api/shareholder/dashboard`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل لوحة التحكم'));
  return data;
}
